import * as ActionTypes from "./actionTypes";

export function trackAuthStatus() {
	return { type: ActionTypes.TRACK_AUTH_STATUS };
}

export function authStatusChanged(user) {
	return { type: ActionTypes.AUTH_STATUS_CHANGED, user };
}

export function logoutUser(message = "Logged Out") {
	return { type: ActionTypes.LOGOUT_USER, message };
}

export function loginSucess(user) {
	return { type: ActionTypes.LOGIN_SUCCESS, user };
}

export function loginError(message) {
	return { type: ActionTypes.LOGIN_ERROR, message };
}
